<template>
  <div>
 <gizlilikSozlesme ref="gizlilikSozlesme"></gizlilikSozlesme>
         <aydinlatmaSozlesme ref="aydinlatmaSozlesme"></aydinlatmaSozlesme>
    <v-footer :fixed="fixed" app>
      <span>&copy; 2018 ARKMAN &mdash; 
         <span class="font-weight-light black--text caption "> Arkman </span>
          <a @click="gizlilikSozlesme()" style="cursor: pointer;" class="font-weight-light info--text caption ">
            <span class="info--text"> {{ $t('Confidentiality') }} </span> </a> <span class="font-weight-light black--text caption "> {{ $t('and') }} </span> <a @click="aydinlatmaSozlesme()"
          style="cursor: pointer;" class="font-weight-light info--text caption"><span class="info--text">
             {{ $t('Clarification-Text') }}
             </span></a></span>
    </v-footer>

  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import gizlilikSozlesme from "@/components/app/customcomp/kvkksozlesme.vue"
  import aydinlatmaSozlesme from "@/components/app/customcomp/aydinlatmasozlesme.vue"
  export default {
    props: ["value"],
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },

    beforeMount: beforeMount,
    watch: {
    },
    methods: {
      gizlilikSozlesme() {
        this.$refs.gizlilikSozlesme.open().then(sonuc => {});
      },
      aydinlatmaSozlesme() {
        this.$refs.aydinlatmaSozlesme.open().then(sonuc => {});
      },
      logout() {
        auth.logout()
      }
    },
    components: {
      gizlilikSozlesme,
      aydinlatmaSozlesme
    },
    data() {
      return {
        clipped: true,
        fixed: false,
        miniVariant: false,
        right: true,
        rightDrawer: false,
        items: [{
            icon: 'business',
            title: this.$t('Login'),
            to: 'anasirket',
          },
          {
            icon: 'shopping_cart',
            title: this.$t('Buy-Products'),
            to: 'urunsatis',

          },
          {
            icon: 'people',
            title: this.$t('Member-Transactions'),
            group: 'uye',
            color: 'blue darken-2',
            items: [{
                title: this.$t('Member-List'),
                to: 'login-uye',
              },
              {
                title: this.$t('Authority-Groups'),
                to: 'login-yetkigruplist',
              },
            ]

          },
        ],

      }
    },
  }

  function beforeMount() {

  }
</script>